import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgRulesSmoking({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M14.015 10.148c.544 0 .985.441.985.985v2.697a.985.985 0 01-.985.985H1.985A.985.985 0 011 13.83v-2.697c0-.544.441-.985.985-.985h12.03zm-3.386 1.555H2.556v1.556h8.073v-1.556zm2.815 0h-1.259v1.556h1.26v-1.555zm-1.037-10.46a.778.778 0 011.13 1.07c-.864.913-.808 1.32.038 2.605l.164.252c1.012 1.603 1.11 2.692-.193 4.115a.778.778 0 11-1.147-1.051c.753-.822.698-1.214-.08-2.396l-.167-.257c-1.08-1.705-1.176-2.823.255-4.338zm-3.11 0a.778.778 0 111.13 1.07c-.865.913-.809 1.32.037 2.605l.186.285c.772 1.221.97 2.002.471 3.084a3.926 3.926 0 01-.686.998.778.778 0 01-1.147-1.051c.2-.217.336-.417.42-.6.23-.495.114-.862-.5-1.796l-.167-.257c-1.08-1.705-1.176-2.823.255-4.338z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgRulesSmoking.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgRulesSmoking.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgRulesSmoking svgRef={ref} {...props} />);
export default ForwardRef;
